import React from 'react';
import { advantages } from '../data/mock';
import { Clock, PiggyBank, Trophy, Shield } from 'lucide-react';

const iconMap = {
  'clock': Clock,
  'piggy-bank': PiggyBank,
  'trophy': Trophy,
  'shield': Shield
};

const Advantages = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-green-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-4 relative">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4">
            Pourquoi choisir <span className="text-green-400">3DLoc</span> ?
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            Avec plus de 300 références en stock, nous vous proposons la location d'une gamme variée de matériel.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((advantage, index) => {
            const IconComponent = iconMap[advantage.icon];
            return (
              <div
                key={advantage.id}
                className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center hover:bg-white/10 hover:border-green-500/50 transition-all duration-300"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-16 h-16 mx-auto mb-6 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center transform group-hover:scale-110 group-hover:rotate-3 transition-all duration-300 shadow-lg shadow-green-500/30">
                  <IconComponent size={28} className="text-white" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">
                  {advantage.title}
                </h3>
                <p className="text-slate-400">
                  {advantage.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional info */}
        <div className="mt-16 text-center">
          <p className="text-slate-400 mb-6">
            Contactez-nous pour récupérer votre demande à Cauville-sur-Mer, à 15min du Havre et Etretat
          </p>
          <a 
            href="#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-bold rounded-xl hover:shadow-xl hover:shadow-green-500/30 transform hover:-translate-y-1 transition-all"
          >
            Demander la livraison
          </a>
        </div>
      </div>
    </section>
  );
};

export default Advantages;
